import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Flip, toast } from 'react-toastify';

import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { Icon } from '../../atoms';
import {
  IconWrapper,
  ToastContainer,
  ToastCustomContainer,
  ToastWrapper
} from './style';

const CloseButton = ({ closeToast }) => (
  <IconWrapper isClose>
    <Icon type="icon-close" size="16" onClick={closeToast} />
  </IconWrapper>
);

CloseButton.propTypes = {
  closeToast: PropTypes.func
};

const Toast = ({ user }) => (
  <>
    {user && (
      <ToastWrapper>
        <ToastContainer
          position="top-center"
          transition={Flip}
          hideProgressBar
          closeOnClick={false}
          icon={false}
          closeButton={CloseButton}
          autoClose={5000}
        />
      </ToastWrapper>
    )}
  </>
);

const ToastSuccess = ({ children }) => (
  <ToastCustomContainer>
    <IconWrapper>
      <Icon
        type="icon-icon-success"
        size={32}
        color={theme().colors.statusGreen}
      />
    </IconWrapper>
    <MainFont type="toast">{children}</MainFont>
  </ToastCustomContainer>
);

ToastSuccess.propTypes = {
  children: PropTypes.node
};

const ToastError = ({ children }) => (
  <ToastCustomContainer>
    <IconWrapper>
      <Icon
        type="icon-exclamation"
        size={32}
        color={theme().colors.statusRed}
      />
    </IconWrapper>
    <MainFont type="toast">{children}</MainFont>
  </ToastCustomContainer>
);
ToastError.propTypes = {
  children: PropTypes.node
};

Toast.TYPE = {
  DEFAULT: 'info',
  SUCCESS: 'success',
  ERROR: 'error'
};

Toast.show = (type = Toast.TYPE.DEFAULT, content = 'Generic error') => {
  switch (type) {
    case Toast.TYPE.SUCCESS:
      toast.success(<ToastSuccess>{content}</ToastSuccess>);
      break;
    case Toast.TYPE.ERROR:
      toast.error(<ToastError>{content}</ToastError>);
      break;
    default:
      toast[type](content);
      break;
  }
};

Toast.propTypes = {
  user: PropTypes.object
};

export default connect(
  state => ({
    user: state?.authentication?.user
  }),
  () => ({})
)(Toast);
